export default __webpack_public_path__ + "static/media/05.045ad887.png";